var filtermenu = {
    filterbutton: undefined,
    filteroptions: undefined,

    init: function () {
        this.filterbutton = document.getElementById('accordionFilter-toggle');
        this.filteroptions = document.getElementById('accordionFilter');
        if (this.Valid()) {
            this.Say('Filters Loaded');
            this.AddEvents();
        }
    },

    Valid: function () {
        if (
            this.filterbutton != undefined ||
            this.filteroptions != undefined
        ) {
            return true;
        } else {
            return false;
        }
    },

    AddEvents: function () {
        this.filterbutton.addEventListener('click', function () {
            filtermenu.Say('Filters Clicked');
            this.classList.toggle('open');
            filtermenu.filteroptions.classList.toggle('open');
        })
    },

    Say: function(str){
        console.log('Filter-Menu.js: ' + str);
    }


}

export default filtermenu;
